import { createSelector } from 'reselect'

import activityObjectNone from 'helpers/activities/activityObjectNone'

const getActivities = state => state.activities

const getActivityByUid = (activities, activityUid) => (
	activities.entities[activityUid] ? activities.entities[activityUid] : activityObjectNone
)

export default createSelector(
	[ getActivities ],
	activities => activityUid => getActivityByUid(activities, activityUid)
)
